module.exports = __webpack_public_path__ + "img/joyc.f547d5df.png";